import _ from 'underscore';
import Marionette from 'marionette';

const View = Marionette.ItemView.extend({
	template: _.template('<span class="msg <%= color %>"><span class="ldi ldi-<%= icon %>"></span> <%= message %></span>')
});

export default View;
